<template>
    <div class="myInfo">
        <div class="header">
            <div class="top">
                <div class="logo">
                    <icon-logo @click="gohome()" logHeight="30"/>
                </div>    
                <div class="title">내정보</div>
                <div class="button_wrap"><button @click="close_myinfo()"></button></div>
            </div>
            <div class="userInfo">
                <div class="profileImg_wrap">
                    <div class="profileImg"                   
                        v-if="user.profile_photo_path"
                        :style="{backgroundImage:`url(${user.profile_photo_url})`}"   
                        >
                    </div> 
                    <div class="profileImg"                   
                        v-if="user.profile_url && !user.profile_photo_path"
                        :style="{backgroundImage:`url(${user.profile_photo_url})`}"                   
                        >
                    </div> 
                    <div class="profileImg"
                        v-if="!user.profile_url && !user.profile_photo_path"         
                        :style="{backgroundImage:`url(${require('@/assets/imgs/profile_blank.jpg')})`}"                   
                        >
                    </div>  
                </div>
                              
                <div v-if="isAuth" class="info_right">
                    <div class="loginUser">
                        <div class="userNick">{{user.nic}}</div>
                        <div class="userEmail">{{user.email}}</div>
                        <div class="userPoint"><font-awesome-icon icon="parking" /> {{addComma(user.point,true)}}</div>
                        <div class="btn_part">
                            <div class="myinfo_btn" @click="linkToMyInfo('m_MyInfo_SelfAuth')">본인인증</div>
                            <div class="myinfo_btn dark_red" @click="logout()">로그아웃</div>    
                        </div>   
                    </div>
                    
                </div>
                
                <div v-else class="info_right">
                    <div class="guestUser">
                        <div class="myinfo_btn" @click="goLogin()">로그인</div>
                        <div class="myinfo_btn  dark_red" @click="goRegister()">회원가입</div>
                    </div>
                </div>
               
                
            </div>           
        </div>
        
        <div class="menu">
            <ul>
                <li class="edit" @click="linkToMyInfo('m_MyInfo_Edit')">                    
                    <div>
                        <span class="conf_text conf_title">회원정보 수정</span>
                        <span class="conf_text conf_desc">휴대전화 등 내 정보를 변경하세요.</span>
                    </div>                      
                </li>
                <li class="item" @click="linkToMyInfo('m_MyInfo_Item')">                    
                    <div>
                        <span class="conf_text conf_title">아이템 정보</span>
                        <span class="conf_text conf_desc">구매 · 사용내역 확인</span>
                    </div>                      
                </li>
                <li class="pshop" @click="linkToMyInfo('m_MyInfo_Pshop')">                    
                    <div>
                        <span class="conf_text conf_title">P샵 상품 정보</span>
                        <span class="conf_text conf_desc">구매내역 확인</span>
                    </div>                      
                </li>
                <li class="recommender" @click="linkToMyInfo('m_MyInfo_Recommender')">                    
                    <div>
                        <span class="conf_text conf_title">추천인 정보</span>
                        <span class="conf_text conf_desc">나의 추천인들, 리워드 기록 보기</span>
                    </div>                      
                </li>
                <li class="friends"  @click="linkToMyInfo('m_MyInfo_Friends')">                    
                    <div>
                        <span class="conf_text conf_title">친구목록</span>
                        <span class="conf_text conf_desc">친구목록 보기</span>
                    </div>                      
                </li>              
                <li class="point" @click="linkToMyInfo('m_MyInfo_Point')">                    
                    <div>
                        <span class="conf_text conf_title">포인트 내역</span>
                        <span class="conf_text conf_desc">포인트 사용내역 보기</span>
                    </div>                      
                </li>
                <li class="myposts" @click="linkToMyInfo('m_MyInfo_Posts')">                    
                    <div>
                        <span class="conf_text conf_title">내 게시글</span>
                        <span class="conf_text conf_desc">작성한 글 모아보기</span>
                    </div>                      
                </li>
            </ul>
        </div>
    </div>
</template>
<script>
import IconLogo from '@/mobile/components/icon/LogoIconOnly';
import { auth } from '@/components/mixins/auth.js';
import { comma } from '@/components/mixins/comma.js';
export default {
    name:'mobile_myinfo_index',
    props:[
        
    ],
    data(){
        return{

        }
    },
    mixins:[
        auth,comma
    ],
    components:{
        IconLogo,
        
    },
    mounted() {
    },
    methods:{       
        linkToMyInfo(routeName, param){   
            if(!this.isAuth)
            {
                if(!confirm('로그인이 필요합니다.'))
                {
                    return;
                }
            }         
            this.$router.push( {name:routeName, params:param} )   
            this.close_myinfo();
        },
        gohome(){
            this.$store.commit('menu/setSwiperIndexHome',0);
            this.close_myinfo();
            this.$router.push({name:'m_Home'});//, params:{init_swiper:true}}
            window.location.reload();           
        },
        close_myinfo(){
            this.$emit('close-myinfo');
        },
        logout() {
            this.$store.dispatch("logout");
            this.$flashMessage.show({
                type: "info",
                title: "로그아웃되었습니다",
                message: "",
            });
            //this.$router.replace('/');
            window.location.reload();
        },
        goLogin(){
            this.$router.push({name:'m_Login'});//, params:{init_swiper:true}}
            this.close_myinfo();            
        },
        goRegister(){
            this.$router.push({name:'m_Register'});
            this.close_myinfo();
            
        }
    }
}
</script>
<style lang="scss" scoped>
.myInfo{
    height: calc(100vh - 50px);
        overflow: scroll;  
    .header{
        background:#0036ac;
        height:195px;
        .top{
            height:45px;
            display: flex;            
            align-items: center;
            justify-content: space-between;
            border-bottom:1px solid #0061ac;
            position: relative;
            .logo{
                height:30px;
                width:40px;
                padding-left:10px;
                flex-grow: 1;
            }
            .title{
                font-size:16px;   
                font-weight: 500;             
                color:#fff;
                flex-grow: 20;
            }
            .button_wrap{
                flex-grow: 1;
                button{
                    position: absolute;
                    width: 50px;
                    height: 54px;
                    top: 0px;
                    right: 0px;  
                    border: 0;
                    background: 0 0;                         
                }
                button::before{
                    transform: rotate(-45deg);  
                    content: "";
                    display: block;
                    position: absolute;
                    top: 15px;
                    left: calc(50% - 1px);
                    width: 2px;
                    height: 22px;
                    background: rgb(255, 255, 255); 
                }   
                button::after{
                    transform: rotate(45deg);   
                    content: "";
                    display: block;
                    position: absolute;
                    top: 15px;
                    left: calc(50% - 1px);
                    width: 2px;
                    height: 22px;
                    background: rgb(255, 255, 255);
                }
            }
            
        }
        .userInfo{
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding:20px;
            .profileImg_wrap{
                 flex-grow: 1;      
                .profileImg{
                    background:#000;
                    width:100px;
                    height:100px;
                    border-radius: 60px;
                    border:1px solid #0061ac;
                    background-size:cover;
                    background-position:center;                         
                }
            }
            
            .info_right{
                flex-grow: 20;               
                padding-left:20px;
                .loginUser{
                    .userNick{
                        color:#fff;
                        font-size:16px;
                        font-weight: 700;
                        padding-left: 10px;
                    }
                    .userEmail{
                        margin-top:3px;
                        color:#0093ce;
                        padding-left: 10px;
                    }
                    .userPoint{
                        margin-top:3px;
                        color:rgb(255, 238, 0);
                        font-size:20px;
                        padding-left: 10px;
                        font-weight: bold;
                    }
                   .btn_part{
                        margin-top:10px;
                        display: flex;                         
                    }
                } 
                .guestUser{
                    display: flex;
                } 
                .myinfo_btn{
                    margin-right:5px;    
                    background:#002273;
                    text-align:center;
                    color:#fff;
                    padding:10px 20px;
                    width:50%;
                    border-radius: 999px;
                } 
                .dark_red{
                    background: #3f0073;
                } 
            }
        }
    }  
    .menu{
          
        ul{
            li{
                position: relative;
                border-bottom:1px solid #efeff0;
                padding:10px 0 10px 51px;
                .conf_text{
                    font-family: naumgothic;
                    font-size:16px;
                    display: block;
                }
                .conf_desc{
                    color: #767678;
                    font-size:14px;
                    margin-top: 4px;
                    
                }
            }   
            li:before{
                content: '';
                position: absolute;
                left: 0;               
                width:51px;
                height:50px;               
                background-position: 0 0;
                background-size: 51px 51px;
            }     
            .edit:before{               
                background-image:url(../assets/imgs/icon/m_icon_profile.png);               
            } 
            .item:before{               
                background-image:url(../assets/imgs/icon/m_icon_item.png);              
            }         
            .pshop:before{              
                background-image:url(../assets/imgs/icon/m_icon_pshop.png);              
            }   
            .recommender:before{              
                background-image:url(../assets/imgs/icon/m_icon_recommender.png);              
            }   
            .friends:before{              
                background-image:url(../assets/imgs/icon/m_icon_friends.png);              
            }   
            .point:before{              
                background-image:url(../assets/imgs/icon/m_icon_point.png);              
            } 
            .myposts:before{              
                background-image:url(../assets/imgs/icon/m_icon_post.png);              
            } 
            li:after{
                content: '';
                position: absolute;
                right: 20px;
                top: 40%;
                width:9px;
                height:16px;
                background-image:url(../assets/imgs/sign.png);
                background-position: -30px -35px;
                background-size: 150px auto;
            }
        }
    }  
}
</style>